import React, { Component } from 'react'
import { TableRow, Button, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'
import { isValidAlphaNumeric } from '../../utils/string'
import { connect } from 'react-redux'

import { openErrorMessage } from '../../actions/message'
import {
  TableCellWithTextField,
  TableCellWithSwitch,
  TableCellWithMultipleSelect,
} from '../common/PureItems'
import EditActionComponent from '../common/EditActionComponent'

//@connect((state) => ({ dispatch: state.dispatch}))
class PosTerminalListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onChangeCreatableOptions = (key) => (values) => {
    let updatedValues =
      (values &&
        values.length &&
        values.map((value) => {
          return value.value
        })) ||
      []

    this.onChange(this.props.onChange(key, updatedValues))
  }
  onError = (message) => this.props.dispatch(openErrorMessage(message))
  onSave = () => {
    if (
      !isValidAlphaNumeric(this.props.data.serialNumber) ||
      !isValidAlphaNumeric(this.props.data.registerId) ||
      !isValidAlphaNumeric(this.props.data.authKey)
    ) {
      this.onError('Special characters not allowed')
      return
    }

    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data = {}, editMode = false, processors = [] } = this.props

    const dataProcessors = []

    processors.forEach((process) =>
      dataProcessors.push({
        label: process.name + ' ' + (process.enabled ? '[ON]' : '[OFF]'),
        value: process.value,
      }),
    )

    return (
      <TableRow>
        <TableCellWithTextField
          valueToRender={data.name}
          editMode={editMode}
          value={data.name}
          onChange={this.onChange('name')}
          type="text"
        />
        <TableCellWithTextField
          valueToRender={data.serialNumber}
          editMode={editMode}
          value={data.serialNumber}
          onChange={this.onChange('serialNumber')}
          type="text"
        />
        <TableCellWithTextField
          valueToRender={data.registerId}
          editMode={editMode}
          value={data.registerId}
          onChange={this.onChange('registerId')}
          type="text"
        />
        <TableCellWithTextField
          valueToRender={data.authKey}
          editMode={editMode}
          value={data.authKey}
          onChange={this.onChange('authKey')}
          type="text"
        />
        <TableCellWithSwitch
          valueToRender={data.online ? 'Active' : 'Inactive'}
          checked={data.online}
          editMode={false}
          onChange={this.onChange('online', true)}
        />
        <TableCellWithSwitch
          valueToRender={data.enabled ? 'Active' : 'Inactive'}
          checked={data.enabled}
          editMode={editMode}
          onChange={this.onChange('enabled', true)}
        />
        <TableCellWithSwitch
          valueToRender={data.manual ? 'Active' : 'Inactive'}
          checked={data.manual}
          editMode={editMode}
          onChange={this.onChange('manual', true)}
        />
        <TableCellWithMultipleSelect
          multi={true}
          value={data.processors}
          onChange={this.onChangeCreatableOptions('processors')}
          valueToRender={
            (data.processors && data.processors.length && data.processors.join(', ')) || ''
          }
          editMode={editMode}
          options={dataProcessors}
          clearable={false}
        />
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            {/* {!editMode ? (
                        <Button
                            className="primary-button margin"
                            onClick={this.props.checkOnlineStatus}
                        >
                            Test Connection
                        </Button>
                        ) : null} */}
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
}))(PosTerminalListItem)



// WEBPACK FOOTER //
// ./src/components/Dejavoo/PosTerminalListItem.js